module.exports = require('./helpers/bundle-url').getBundleURL('fJDP7') + "logo-dark.a922e36b.svg";